import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";
import * as KeyFactory from "./organization-query-key-factory";

/**
 * Gets the organization by id
 */
export const getOrganization = ({ organizationId }: { organizationId: string | null }) => {
  return organizationId === null
    ? Promise.reject(new Error("Invalid organizationId id"))
    : Brm.organizationApi.getOrganizationByID(organizationId);
};

interface IOrganizationsProps {
  organizationId: string | null;
  options?: QueryOption<typeof getOrganization>;
}

/**
 * Custom hook for getting all organizations
 *
 * @param {object} config - react-query configuration
 * @returns
 */
export const useOrganization = ({ organizationId, options = {} }: IOrganizationsProps) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: KeyFactory.organizationKeys.org(organizationId),
    queryFn: () => getOrganization({ organizationId }),
  });
};
